import store from '@/store';
import { GIFT_TYPE_ONE_OFF, GIFT_TYPE_SUBSCRIPTION } from '@/constants/Gifting';

const i18n = require('@/i18n').default;

export default {
    steps: [
        {
            routeName: 'account.gifting.choose-your-gift',
            enabled: true,
            title: i18n.t('GIFTING_NAV_CHOOSE'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.number-of-deliveries',
            enabled: true,
            title: i18n.t('GIFTING_NAV_NUMBER_DELIVERIES'),
            type: [
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.delivery-address',
            enabled: true,
            title: i18n.t('GIFTING_NAV_DELIVERY_ADDRESS'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.freddies-addons',
            enabled: store.getters['account/getGiftingVaseEnabled'],
            title: i18n.t('GIFTING_NAV_EXTRAS'),
            type: [
                GIFT_TYPE_ONE_OFF,
            ],
        },
        {
            routeName: 'account.gifting.freddies-shop',
            enabled: store.getters['account/getShopInGiftingEnabled'],
            title: i18n.t('GIFTING_NAV_EXTRAS'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.delivery-day',
            enabled: true,
            title: i18n.t('GIFTING_NAV_DELIVERY_DATE'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.gift-card',
            enabled: true,
            title: i18n.t('GIFTING_NAV_PERSONALISED_CARD'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.payment',
            enabled: true,
            title: i18n.t('GIFTING_NAV_PAYMENT_DETAILS'),
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.thank-you',
            enabled: true,
            title: '',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
    ],
};
